import { render, staticRenderFns } from "./EditResult.vue?vue&type=template&id=10c959d9&scoped=true&"
import script from "./EditResult.vue?vue&type=script&lang=js&"
export * from "./EditResult.vue?vue&type=script&lang=js&"
import style0 from "./EditResult.vue?vue&type=style&index=0&id=10c959d9&lang=scss&scoped=true&"
import style1 from "./EditResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c959d9",
  null
  
)

export default component.exports